export default __webpack_public_path__ + "static/media/models6.ebdbc252.jfif";